/**
 * SELECT EXCEL FILE VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import xhr from './../../../../utils/xhr';
import { hashHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import ButtonWithInnerSpinner from './../../../../reusable/ButtonWithInnerSpinner/ButtonWithInnerSpinner.index';

export default class SelectExcelFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonState:    "loading",
            paragraphClass: "hidden",
            active:         '',
            inactive:       '',
            subscription:   ''
        };

        this.goToCreateNewEntityPage = this.goToCreateNewEntityPage.bind(this);
    }

    getActiveCount() {
        return xhr.get({
            url: '/api/entities/companies/active/count'
        }).then((response) => {
            this.setState({
                active: response.body
            });
        });
    }

    getInactiveCount() {
        return xhr.get({
            url: '/api/entities/companies/non-active/count'
        }).then((response) => {
            this.setState({
                inactive: response.body
            });
        });
    }

    getSubscription() {
        return xhr.get({
            url: '/api/customer/subscription'
        }).then((response) => {
            this.setState({
                subscription: response.body.maximumNoOfThirdParties
            });
        });
    }

    componentWillMount() {

        Promise.all([
            this.getSubscription(),
            this.getActiveCount(),
            this.getInactiveCount()
        ]).then(() => {
            if (this.state.subscription - this.state.active - this.state.inactive > 0) {
                this.setState({
                    buttonState:    "enabled",
                    paragraphClass: "hidden"
                });
            } else {
                this.setState({
                    buttonState:    "disabled",
                    paragraphClass: ""
                });
            }
        }).catch((error) => {
            xhr.handleAllErrors(error);
        });

    }

    goToCreateNewEntityPage() {
        hashHistory.push('/create-new-entity');
    }

    render() {

        return (<form className="upload-wizard__button-container upload-wizard__form"
                      encType="multipart/form-data"
                      id="batch-upload-form"
                      method="post" action="/api/template/upload">

                <div className="card-title">
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.Step2Heading" />
                </div>

                <div className="card-image step-two"></div>

                <div className="step-heading">
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.stepArrow2" />
                </div>

                <p><FormattedMessage id="Entities_Steps_UIText_batchUpload.step2Instruction1" /></p>

                <p className={"disabled-text select-file " + this.state.paragraphClass}>
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.step2Instruction2" />
                </p>

                <p className={"disabled-text select-file " + this.state.paragraphClass}>
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.step2Instruction3" />
                </p>

                <div className="button-wrapper">

                    <ButtonWithInnerSpinner buttonType="button"
                                            buttonClass={this.props.stage === 'success' ?
                                                'button-primary-lg upload-wizard__buttons upload-wizard__buttons--select-file disabled' :
                                                'button-primary-lg upload-wizard__buttons upload-wizard__buttons--select-file'}
                                            buttonClick={this.props.stage === 'success' ?
                                                null : this.props.selectFile}
                                            buttonMessageId="Entities_Steps_UIText_batchUpload.buttonSelectFile"
                                            buttonState={this.state.buttonState} />
                    <input className="upload-wizard__upload-input"
                           name="companiesSpreadsheet"
                           type="file"
                           onChange={this.props.fileSelected} />

                </div>
            </form>

        );

    }
}


// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/InitialStage/SelectExcelFile.jsx